import _ from 'lodash';
import VueI18n from 'vue-i18n';
import Vue from 'vue';
import { getPluginTranslations } from '@/presentation/pages/detail/basic/interface_lock/infoSync';
import { getCurrentLanguage } from '@cores/utils/getCurrentLanguage';
Vue.use(VueI18n);
export const i18nSymbol = Symbol.for('i18n');
const locale = getCurrentLanguage();
export const i18n = new VueI18n({
    locale,
    messages: {},
    fallbackLocale: 'en',
});
export async function getMessage(locale) {
    let results = [];
    let resultPromises = [];
    if (locale === 'cn') {
        resultPromises = ([
            import(/* webpackChunkName: "component-locale-cn" */ '@patsnap-biz/tag-legal/locales/cn').then(data => data.default),
            import(/* webpackChunkName: "component-locale-cn" */ '@patsnap-biz/patent-field/locales/cn').then(data => data.default),
            import(/* webpackChunkName: "component-locale-cn" */ '@patsnap-biz/authority/locales/cn').then(data => data.default),
            import(/* webpackChunkName: "component-locale-cn" */ '@patsnap-biz/patent-type/locales/cn').then(data => data.default),
            import(/* webpackChunkName: "component-locale-cn" */ '@patsnap-biz/email-alert/locales/cn').then(data => data.default),
            import(/* webpackChunkName: "component-locale-cn" */ '@patsnap-biz/email-input/locales/cn').then(data => data.default),
            import('CommonMessages/common-errorcode/cn.json'),
            import('CommonMessages/analytics-integrate/cn.json'),
            import('CommonMessages/analytics-matrix-deprecated/cn.json'),
            import('CommonMessages/common-patent/cn.json'),
            import('CommonMessages/common-country/cn.json'),
            import('CommonMessages/common-product/cn.json'),
            import('CommonMessages/analytics-snap-business/cn.json'),
            import('CommonMessages/analytics-workspace/cn.json'),
            import('@/plugins/patent-consult/i18n').then(data => {
                return data.default[locale];
            }),
        ]);
    }
    else if (locale === 'en') {
        resultPromises = ([
            import(/* webpackChunkName: "component-locale-en" */ '@patsnap-biz/tag-legal/locales/en').then(data => data.default),
            import(/* webpackChunkName: "component-locale-en" */ '@patsnap-biz/patent-field/locales/en').then(data => data.default),
            import(/* webpackChunkName: "component-locale-en" */ '@patsnap-biz/authority/locales/en').then(data => data.default),
            import(/* webpackChunkName: "component-locale-en" */ '@patsnap-biz/patent-type/locales/en').then(data => data.default),
            import(/* webpackChunkName: "component-locale-en" */ '@patsnap-biz/email-alert/locales/en').then(data => data.default),
            import(/* webpackChunkName: "component-locale-cn" */ '@patsnap-biz/email-input/locales/en').then(data => data.default),
            import('CommonMessages/common-errorcode/en.json'),
            import('CommonMessages/analytics-integrate/en.json'),
            import('CommonMessages/analytics-matrix-deprecated/en.json'),
            import('CommonMessages/common-patent/en.json'),
            import('CommonMessages/common-country/en.json'),
            import('CommonMessages/common-product/en.json'),
            import('CommonMessages/analytics-snap-business/en.json'),
            import('CommonMessages/analytics-workspace/en.json'),
            import('@/plugins/patent-consult/i18n').then(data => data.default[locale]),
        ]);
    }
    else if (locale === 'jp') {
        resultPromises = ([
            import(/* webpackChunkName: "component-locale-jp" */ '@patsnap-biz/tag-legal/locales/jp').then(data => data.default),
            import(/* webpackChunkName: "component-locale-jp" */ '@patsnap-biz/patent-field/locales/jp').then(data => data.default),
            import(/* webpackChunkName: "component-locale-jp" */ '@patsnap-biz/authority/locales/jp').then(data => data.default),
            import(/* webpackChunkName: "component-locale-jp" */ '@patsnap-biz/patent-type/locales/jp').then(data => data.default),
            import(/* webpackChunkName: "component-locale-jp" */ '@patsnap-biz/email-alert/locales/jp').then(data => data.default),
            import(/* webpackChunkName: "component-locale-cn" */ '@patsnap-biz/email-input/locales/jp').then(data => data.default),
            import('CommonMessages/common-errorcode/jp.json'),
            import('CommonMessages/analytics-integrate/jp.json'),
            import('CommonMessages/analytics-matrix-deprecated/jp.json'),
            import('CommonMessages/common-patent/jp.json'),
            import('CommonMessages/common-country/jp.json'),
            import('CommonMessages/common-product/jp.json'),
            import('CommonMessages/analytics-snap-business/jp.json'),
            import('CommonMessages/analytics-workspace/jp.json'),
            import('@/plugins/patent-consult/i18n').then(data => data.default[locale]),
        ]);
    }
    else if (locale === 'tw') {
        resultPromises = ([
            import(/* webpackChunkName: "component-locale-tw" */ '@patsnap-biz/tag-legal/locales/tw').then(data => data.default),
            import(/* webpackChunkName: "component-locale-tw" */ '@patsnap-biz/patent-field/locales/tw').then(data => data.default),
            import(/* webpackChunkName: "component-locale-tw" */ '@patsnap-biz/authority/locales/tw').then(data => data.default),
            import(/* webpackChunkName: "component-locale-tw" */ '@patsnap-biz/patent-type/locales/tw').then(data => data.default),
            import(/* webpackChunkName: "component-locale-tw" */ '@patsnap-biz/email-alert/locales/tw').then(data => data.default),
            import(/* webpackChunkName: "component-locale-tw" */ '@patsnap-biz/email-input/locales/tw').then(data => data.default),
            import('CommonMessages/common-errorcode/tw.json'),
            import('CommonMessages/analytics-integrate/tw.json'),
            import('CommonMessages/analytics-matrix-deprecated/tw.json'),
            import('CommonMessages/common-patent/tw.json'),
            import('CommonMessages/common-country/tw.json'),
            import('CommonMessages/common-product/tw.json'),
            import('CommonMessages/analytics-snap-business/tw.json'),
            import('CommonMessages/analytics-workspace/tw.json'),
            import('@/plugins/patent-consult/i18n').then(data => data.default[locale]),
        ]);
    }
    results = await Promise.all([...resultPromises, getPluginTranslations(locale)]);
    const data = results.reduce((obj, data) => _.merge(obj, data), {});
    return data;
}
